// import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'weekplan_list',
    component: () => import('./List.vue'),
  },
]
